// extracted by mini-css-extract-plugin
export default {"payment-modes":"PaymentModes_payment-modes__+IQsN","payment-modes-field":"PaymentModes_payment-modes-field__u4m+E"};